<app-grid-simmer *ngIf="isLoding === true"></app-grid-simmer>
<section class="popular-video gray-bg" *ngIf="isLoding === false">
  <div class="container">
    <div class="row mob-content" *ngIf="isContent === true">
      <div class="col">
        <div class="">
          <h1 class="mb-3 slider-heading">
            {{ gridConfig.grid_content.coursesTitle }}
          </h1>
          <p class="mb-0 text-secondary">
            {{ gridConfig.grid_content.coursesDiscription }}
          </p>
          <hr />
          <a [routerLink]="['/list/popular-trending-series']" class="text-secondary d-flex align-items-center mb-3">
            {{ "HOME.VIEW_ALL" | translate }}
            <span class="mdi mdi-chevron-right font-18 ml-1"></span>
          </a>
        </div>
      </div>
    </div>
    <div class="row slide-list">
      <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-4 desk-content" *ngIf="isContent === true">
        <div class="">
          <h1 class="mb-3 slider-heading">
            {{ gridConfig.grid_content.coursesTitle }}
          </h1>
          <p class="mb-0 text-secondary">
            {{ gridConfig.grid_content.coursesDiscription }}
          </p>
          <hr />
          <a [routerLink]="['/list/popular-trending-series']" class="text-secondary d-flex align-items-center mb-3">
            {{ "HOME.VIEW_ALL" | translate }}
            <span class="mdi mdi-chevron-right font-18 ml-1"></span>
          </a>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2 pr-0 mb-3" *ngFor="let watch of popularVideos">
        <app-grid [data]="watch" [gridType]="'square'" [type]="'popular_courses'"></app-grid>
      </div>
    </div>
  </div>
</section>